import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 30000 });

const LS_CLIENT = "m365matrix.clientId";

export const getClientId = () => {
  let id = window.localStorage.getItem(LS_CLIENT);
  if (!id) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
    window.localStorage.setItem(LS_CLIENT, id);
  }
  return id;
};

export const errorMessage = (err, fallback = "Something went wrong") => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length) {
    const first = detail[0];
    return `${(first.loc || []).slice(1).join(".")}: ${first.msg}`;
  }
  return err?.message || fallback;
};

const adminHeaders = (key) => ({ headers: { "X-Admin-Key": key } });

export const api = {
  matrix: () => http.get("/matrix").then((r) => r.data),
  publicProposal: (token) => http.get(`/public/proposals/${token}`).then((r) => r.data),

  selections: {
    list: (clientId) => http.get("/selections", { params: { client_id: clientId } }).then((r) => r.data),
    create: (payload) => http.post("/selections", payload).then((r) => r.data),
    get: (id) => http.get(`/selections/${id}`).then((r) => r.data),
    remove: (id) => http.delete(`/selections/${id}`).then((r) => r.data),
  },

  maps: {
    list: (clientId) => http.get("/maps", { params: { client_id: clientId } }).then((r) => r.data),
    create: (payload) => http.post("/maps", payload).then((r) => r.data),
    update: (id, payload) => http.put(`/maps/${id}`, payload).then((r) => r.data),
    remove: (id) => http.delete(`/maps/${id}`).then((r) => r.data),
  },

  admin: {
    verify: (key) => http.get("/admin/verify", adminHeaders(key)).then((r) => r.data),
    export: (key) => http.get("/admin/export", adminHeaders(key)).then((r) => r.data),
    import: (key, data) => http.post("/admin/import", data, adminHeaders(key)).then((r) => r.data),
    reset: (key) => http.post("/admin/reset", null, adminHeaders(key)).then((r) => r.data),
    patchPlan: (key, id, patch) => http.patch(`/admin/plans/${id}`, patch, adminHeaders(key)).then((r) => r.data),
    patchAddon: (key, name, patch) => http.patch(`/admin/addons/${encodeURIComponent(name)}`, patch, adminHeaders(key)).then((r) => r.data),
  },
};
